import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue'

import Radio from '@/components/LoginRegister/common/inputs/Radio/v1/Radio.vue'

type Value = string | number | boolean
type Option = {
    label?: string
    value: boolean
    imgSrc?: string
}
type OptionList = Option[]

interface Props {
    options: OptionList
    selectedOption?: Option
    disabled?: boolean
}
interface Emits {
    (e: "radioClick", option: Option): void
}

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
    options: {},
    selectedOption: {},
    disabled: { type: Boolean }
  },
  emits: ["radioClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// emit
const emit = __emit


// handlers
const handleClick = (option: Option) => {
    emit('radioClick', option)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option, option_i) => {
      return (_openBlock(), _createBlock(Radio, {
        onRadioClick: ()=>handleClick(option),
        active: 
                (props.selectedOption && props.selectedOption.value === option.value) ? true : false
            ,
        key: option_i,
        option: option,
        disabled: props.disabled
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", { option: option })
        ]),
        _: 2
      }, 1032, ["onRadioClick", "active", "option", "disabled"]))
    }), 128))
  ]))
}
}

})